(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-subnav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var nav = document.querySelector('.product-subnav');
    if (!nav) return;
    var links = Array.prototype.slice.call(nav.querySelectorAll('.product-subnav__link'));
    var wrap = nav.closest('.shopify-section') || nav;
    function headerH() {
      /* przyklejony jest cały blok nagłówka (pasek + menu): bierzemy jego wysokość, gdy jest sticky; inaczej --header-height */
      var hs = document.querySelector('.header-section');
      if (hs && getComputedStyle(hs).position === 'sticky') return hs.getBoundingClientRect().height;
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      if (!v && hs) v = hs.offsetHeight;
      return v || 0;
    }
    function syncTop() { wrap.style.setProperty('--subnav-top', headerH() + 'px'); }
    syncTop(); window.addEventListener('resize', syncTop); setTimeout(syncTop, 800); setTimeout(syncTop, 2500);
    function offset() { return headerH() + nav.offsetHeight + 12; }
    function targetOf(link) {
      var sel = link.getAttribute('data-subnav-target');
      try { return document.querySelector(sel); } catch (e) { return null; }
    }
    /* linki bez celu w tym szablonie znikają; celom dopisujemy czytelne kotwice (#sklad-produktu itd.) */
    links = links.filter(function (l) {
      var t = targetOf(l); if (!t) { l.parentElement.remove(); return false; }
      var a = l.getAttribute('data-subnav-anchor');
      if (a && !document.getElementById(a)) {
        var span = document.createElement('span'); span.id = a; span.className = 'product-subnav-anchor'; span.setAttribute('aria-hidden', 'true');
        t.insertBefore(span, t.firstChild);
      }
      return true;
    });
    var list = nav.querySelector('.product-subnav__list'), activeLink = null;
    function setActive(el) {
      if (el === activeLink) return;
      activeLink = el;
      links.forEach(function (l) { l.classList.toggle('is-active', l === el); });
      /* tylko poziome dosunięcie aktywnej pozycji w pasku (scrollIntoView przewijałoby też okno) */
      if (el && list && list.scrollWidth > list.clientWidth) {
        var left = el.offsetLeft - (list.clientWidth - el.offsetWidth) / 2;
        list.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
    /* przewinięcie do celu z korektą: obrazy i bloki aplikacji nad celem doładowują się po skoku i przesuwają treść,
       więc pilnujemy pozycji do ~4 s - ale tylko dopóki użytkownik sam nie przewinie (kółko, dotyk, klawisz, pasek) */
    var job = null;
    function cancelJob() { if (job) { job.cancelled = true; job = null; } }
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) { window.addEventListener(ev, cancelJob, { passive: true }); });
    function scrollToTarget(t, link) {
      cancelJob();
      var me = { cancelled: false, tries: 0, stable: 0, last: null };
      job = me;
      function go() {
        if (me.cancelled) return;
        if (me.last !== null && Math.abs(window.scrollY - me.last) > 30) { cancelJob(); return; }  /* ktoś przewinął */
        var y = Math.max(0, t.getBoundingClientRect().top + window.scrollY - offset());
        window.scrollTo({ top: y, behavior: 'instant' });
        me.last = window.scrollY; me.tries++;
        setTimeout(function () {
          if (me.cancelled) return;
          var diff = Math.abs(t.getBoundingClientRect().top - offset());
          if (diff <= 4) me.stable++; else me.stable = 0;
          if (me.stable < 6 && me.tries < 26) go(); else { job = null; if (link) setActive(link); }
        }, 150);
      }
      go();
    }
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var t = targetOf(link); if (!t) return;
        e.preventDefault();
        scrollToTarget(t, link);
        if (history.replaceState) history.replaceState(null, '', link.getAttribute('href'));
      });
    });
    var pairs = links.map(function (l) { return { link: l, el: targetOf(l) }; });
    function spy() {
      if (job) return;   /* w trakcie korekty po kliknięciu nie zmieniamy podświetlenia */
      var line = offset() + 90, current = null;   /* tolerancja: sekcja zaczyna się kilkanaście px pod menu po kliknięciu */
      pairs.forEach(function (p) { if (p.el.getBoundingClientRect().top - line <= 0) current = p.link; });
      setActive(current);
    }
    var ticking = false;
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { spy(); ticking = false; }); } }, { passive: true });
    spy();
    /* wejście z kotwicą w adresie (np. /products/x#sklad-produktu) */
    if (location.hash) {
      var hl = links.filter(function (l) { return l.getAttribute('href') === location.hash; })[0];
      if (hl) setTimeout(function () { var t = targetOf(hl); if (t) scrollToTarget(t, hl); }, 400);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
